import {Directive, Input, TemplateRef} from '@angular/core';

@Directive({
    selector: '[mydocmaCustomField]'
})
export class CustomFieldTemplateDirective {

    @Input()
    public mydocmaCustomField: string;

    constructor(public template: TemplateRef<any>) {
    }
}
